import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Exact same SVG logo as Login.js
const Logo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15263.4 3560.32" style={{ width: '100%', height: 'auto', display: 'block' }} aria-label="ChanakyaX">
    <path fill="#FC5C0B" d="M13821.58 1767.69c29.82,-67.16 129.86,-166.84 176.62,-225.85l1265.19 -1541.84c-72.91,44.24 -958.38,861.93 -1046.05,951.47 -73.2,74.76 -133.38,130.95 -207.85,196.97 -115.46,102.34 -331.11,359.88 -403.04,398.54 -109.82,-138.98 -440.05,-452.63 -508.09,-566.8l-376.95 -0.81c27.87,74.49 129.25,154.75 180.19,212.36l525.64 573.92c-20.18,52.59 -238.08,304.7 -284.77,358.39 -89.85,103.32 -827.29,975.23 -858.4,1042.22l894.31 -685.24c166.19,-124.82 334.53,-406.43 445.38,-488.22 108.99,111.67 205.94,209.69 294.46,317.91 102.93,125.84 97.41,114.34 193.31,113.42 96.42,-0.92 210.43,3.99 304.07,-3.75 -32.27,-73.18 -545.13,-557.76 -594.04,-652.69z"/>
    <path fill="#ffffff" d="M6267.05 2408.83l259.02 7.13 -3.47 -1277.96 -239.85 1.58 -8.4 890.95 -16.86 -19.07c-74.72,-55.17 -653.64,-655.92 -762.6,-768.93 -138.86,-144.03 -123.9,-147.95 -369.32,-128.47l5.46 1302.11c68.73,3.49 191.77,16.85 241.05,-9.12 32.6,-60.92 12.59,-741.84 10.3,-872.68l884.66 874.46z"/>
    <polygon fill="#ffffff" points="1973.31,1919.85 2787.18,1919.55 2789.06,2417.2 3052.41,2415.02 3052.05,1125.45 2788.64,1125.1 2782.22,1675.03 1971.99,1674.38 1969.16,1123.99 1708.58,1129.82 1712.66,2417.23 1970.19,2417.72"/>
    <path fill="#ffffff" d="M1350.08 1370.5c28.93,-41.1 106.82,-185.93 122.92,-246.2 -246.97,4.69 -809.94,-30.26 -1011.86,29.08 -586.87,172.47 -617.64,1004.21 -69,1213.44 207.71,79.21 701.49,56.65 959.06,51.46l115.82 -245.71c-258.8,-0.16 -524.78,4.7 -782.73,-1.19 -226.75,-5.18 -396.19,-136.09 -410.93,-350.47 -39.9,-580.06 603.74,-444.05 1076.71,-450.4z"/>
    <path fill="#ffffff" d="M7553.12 1462.41c83.47,89.42 489.4,901.38 543.34,959.24l303.59 -3.29c-22.67,-76.7 -325.16,-570 -389.75,-689.65 -67.82,-125.63 -128.68,-229.39 -196.06,-348.27 -111.53,-196.8 -123.17,-271.27 -261.57,-267.55 -128.5,3.45 -143.29,92.16 -255.3,288.54 -67.31,118.01 -127.22,221.6 -193.69,336.86 -57.14,99.08 -363.56,612.02 -382.04,678.56l295.5 0.76 535.98 -955.19z"/>
    <path fill="#ffffff" d="M11127.33 2419.38c307.64,0.45 285.66,31 349.1,-91.64 52.53,-101.57 447.59,-816.68 486.36,-857.52 2.39,2.67 5.45,6.42 6.89,8.26l263.55 464.85c88.71,159.81 172.38,318.09 260.87,477.95l311.25 1.16c-31.87,-100.64 -139.79,-252.36 -194.3,-353.77l-391.74 -683.03c-112.09,-189.45 -115.2,-272.65 -256.09,-269.11 -125.13,3.14 -151.35,110.39 -254.62,285.46l-394.12 680.47c-44.51,75.8 -168.52,269.27 -187.15,336.93z"/>
    <path fill="#ffffff" d="M3557.75 2417.64c62.19,-70.09 444.98,-834.11 543.16,-953.52 94.01,159.02 179.06,321.57 269.7,483.62l264.31 472.35 300.47 -3.46c-29.48,-85.74 -136.68,-253.64 -188.52,-341.7l-390.84 -683.98c-103.58,-172.88 -115.74,-274.6 -251.48,-275.12 -108.04,-0.42 -119.9,31.11 -165.28,110.37 -114.63,200.17 -662.8,1132.3 -670.68,1191.01l289.16 0.44z"/>
    <path fill="#ffffff" d="M10842.51 2074.77c-0.04,-97.1 -14.37,-112.55 36.47,-176.79 79.76,-100.78 596.47,-735.04 608.4,-773.2l-311.54 0.68 -463.6 594.6 -461.09 -595.7 -314.62 -1.81 184.17 239.83c66.21,84.11 117,143.75 178.86,225.86 58.35,77.43 123.48,160.78 183.7,235.15 106.16,131.1 93.25,91.15 93.24,307.19l3.43 291.02 261.89 -4.17 0.66 -342.68z"/>
    <path fill="#ffffff" d="M8601.33 2423.64l259.43 -8.84 -0.03 -649c46.99,18.06 178.25,162.93 228.46,209.5l441.53 423.84c62.04,43.21 304.78,15.89 404.37,18.81l-541.56 -509.63c-50.14,-42.1 -142.36,-121.85 -179.64,-168.55 94.49,-110.09 606.98,-577.77 636.47,-624.86 -109.55,-8.78 -302.21,-27.01 -369.2,27.67 -139.93,114.23 -515.97,533.52 -619.31,595.98l-2.18 -626.4 -258.97 -0.43 26.88 1.27c132.99,7 74.23,26.23 236.48,26.57 0,183.27 -20.26,266.99 -3.25,390.82l-24.59 893.23 -234.89 0z"/>
    <path fill="#F55C0C" d="M11809.25 2410.22c60.65,-79 85.99,-178.99 158.61,-238.89l131.75 243.68 134.65 -1.31c-20.99,-85.95 -95.34,-194.38 -132.9,-267.72 -28.92,-56.48 -96.86,-198.76 -138.57,-237.54 -43.16,54.49 -264.73,429.43 -284.18,507.24l130.64 -5.46z"/>
    <path fill="#FC610C" d="M3811.99 2412.45c147.13,8.7 122.98,19.87 182.24,-85.1 25.23,-44.7 62.35,-112.63 96.31,-154.19 40.97,26.47 128.95,203.5 145.35,242.85l141.64 -6.22 -269.27 -505.88c-47.55,31.35 -274.79,441.19 -296.26,508.53z"/>
    <path fill="#FC610C" d="M7416.67 2412.85c29.25,-68.43 99.16,-199.87 148.68,-240.16l140.32 242.37 126.98 -3.07c-45.56,-153.06 -203.91,-355.47 -264.24,-507.7l-15.79 15.2c-1.93,2.14 -5.21,5.46 -7.24,7.88 -1.99,2.37 -4.64,5.65 -6.59,8.17 -10.75,13.91 -7.16,10.35 -16.77,25.73l-105.83 186.98c-40.33,70.17 -115.94,181.56 -136.32,265.55l136.81 -0.95z"/>
  </svg>
);

// Shared input style — exact same as Login.js
const inputStyle = {
  width: '100%', padding: '11px 14px', borderRadius: 8,
  border: '1.5px solid #e5e7eb', fontSize: 14, outline: 'none',
  background: '#fff', color: '#111827',
  transition: 'border-color 0.2s, box-shadow 0.2s',
};
const onFocus = e => { e.target.style.borderColor = '#0f1f45'; e.target.style.boxShadow = '0 0 0 3px rgba(15,31,69,0.08)'; };
const onBlur  = e => { e.target.style.borderColor = '#e5e7eb'; e.target.style.boxShadow = 'none'; };

function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ firm_name: '', owner_name: '', email: '', phone: '', password: '', confirm_password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  // null while we haven't checked yet — treated as "not open" so the form
  // never flashes open before we know for sure (fail closed, same as the server).
  const [registrationOpen, setRegistrationOpen] = useState(null);

  useEffect(() => {
    const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    fetch(`${BASE}/api/auth/registration-status`)
      .then(res => res.json())
      .then(data => setRegistrationOpen(!!data.enabled))
      .catch(() => setRegistrationOpen(false));
  }, []);

  const set = (key) => (e) => setForm(f => ({ ...f, [key]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');

    if (form.password !== form.confirm_password) {
      setError('Passwords do not match.'); return;
    }
    if (form.password.length < 8) {
      setError('Password must be at least 8 characters.'); return;
    }

    setLoading(true);
    try {
      const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      const res = await fetch(`${BASE}/api/auth/register-firm`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          firm_name: form.firm_name,
          owner_name: form.owner_name,
          email: form.email,
          phone: form.phone,
          password: form.password,
        }),
      });
      const data = await res.json();
      if (res.ok) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        setSuccess(`Welcome to ChanakyaX! Your Firm Code is: ${data.firm_code}`);
        setTimeout(() => navigate('/dashboard'), 1800);
      } else {
        setError(data.message || 'Registration failed. Please try again.');
      }
    } catch {
      setError('Cannot connect to server. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#f1f5f9',
      padding: '16px', boxSizing: 'border-box',
    }}>
      <div style={{
        width: '100%', maxWidth: '900px', display: 'flex',
        flexDirection: 'row', borderRadius: '20px', overflow: 'hidden',
        boxShadow: '0 25px 60px rgba(0,0,0,0.15)', minHeight: '580px', margin: '0 auto',
      }}>

        {/* ── LEFT PANEL — identical to Login ── */}
        <div className="login-left-panel" style={{
          background: 'linear-gradient(135deg, #060d1f 0%, #0a1628 40%, #0d1f3c 100%)',
          padding: '40px', display: 'flex', flexDirection: 'column',
          justifyContent: 'space-between', position: 'relative', overflow: 'hidden', flexShrink: 0,
        }}>
          {/* Decorative blobs */}
          <div style={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none' }}>
            <div style={{ position: 'absolute', width: 400, height: 400, borderRadius: '50%', opacity: 0.10, background: 'radial-gradient(circle, #1a4080 0%, transparent 70%)', top: -100, right: -100 }} />
            <div style={{ position: 'absolute', width: 300, height: 300, borderRadius: '50%', opacity: 0.10, background: 'radial-gradient(circle, #1a4080 0%, transparent 70%)', bottom: -50, left: -50 }} />
          </div>

          {/* Logo */}
          <div style={{ position: 'relative', zIndex: 10, width: '300px' }}>
            <Logo />
          </div>

          {/* Benefits */}
          <div style={{ position: 'relative', zIndex: 10 }}>
            <h2 style={{ fontSize: 26, fontWeight: 700, color: '#fff', marginBottom: 8, lineHeight: 1.3 }}>
              Start your{' '}
              <span style={{ color: '#60a5fa' }}>14-day</span>{' '}
              <span style={{ color: '#f97316' }}>free trial.</span>
            </h2>
            <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)', marginBottom: 28, lineHeight: 1.6 }}>
              Full Pro access. No credit card required. Cancel anytime.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
              {[
                { color: '#60a5fa', label: 'CRM, Finance, Tasks — all in one platform' },
                { color: '#f97316', label: 'GST-compliant invoicing with your branding' },
                { color: '#34d399', label: 'MCA workspace for Companies Act compliance' },
                { color: '#a78bfa', label: 'WhatsApp lead capture & AI assistant' },
              ].map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <div style={{ width: 8, height: 8, borderRadius: '50%', background: item.color, marginTop: 5, flexShrink: 0 }} />
                  <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.75)', lineHeight: 1.5 }}>{item.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Trusted note */}
          <div style={{ position: 'relative', zIndex: 10 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <svg width="14" height="14" fill="none" stroke="rgba(255,255,255,0.4)" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>Trusted by modern CA and professional firms</span>
            </div>
          </div>
        </div>

        {/* ── RIGHT PANEL — registration form ── */}
        <div style={{ flex: 1, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

          {/* Mobile logo */}
          <div className="login-mobile-logo" style={{ display: 'none', position: 'absolute', top: 24, left: '50%', transform: 'translateX(-50%)', width: 160 }}>
            <Logo />
          </div>

          <div className="login-right-panel-inner" style={{ width: '100%', maxWidth: 400, padding: '44px 40px' }}>

            <div style={{ marginBottom: 28 }}>
              <h1 style={{ fontSize: 24, fontWeight: 700, color: '#0f1f45', marginBottom: 6, lineHeight: 1.2 }}>
                Create your workspace
              </h1>
              <p style={{ fontSize: 14, color: '#6b7280' }}>
                Already have an account?{' '}
                <Link to="/" style={{ color: '#2563eb', fontWeight: 500, textDecoration: 'none' }}
                  onMouseEnter={e => { e.currentTarget.style.textDecoration = 'underline'; }}
                  onMouseLeave={e => { e.currentTarget.style.textDecoration = 'none'; }}>
                  Sign in
                </Link>
              </p>
            </div>

            {registrationOpen === false && (
              <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 10, padding: '18px 16px', textAlign: 'center' }}>
                <div style={{ fontSize: 28, marginBottom: 8 }}>🚧</div>
                <p style={{ fontSize: 14, fontWeight: 600, color: '#92400e', marginBottom: 4 }}>New signups are paused</p>
                <p style={{ fontSize: 13, color: '#a16207' }}>ChanakyaX is currently in private setup. Please contact us if you'd like early access.</p>
              </div>
            )}

            {registrationOpen === null && (
              <p style={{ fontSize: 13, color: '#9ca3af', textAlign: 'center' }}>Checking availability…</p>
            )}

            {registrationOpen === true && (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

              {/* Firm Name */}
              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>
                  Firm / Company Name <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <input
                  type="text" required placeholder="e.g. Legal Chanakya Corporate Advisors LLP"
                  value={form.firm_name} onChange={set('firm_name')}
                  style={inputStyle} onFocus={onFocus} onBlur={onBlur}
                />
              </div>

              {/* Owner Name */}
              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>
                  Your Full Name <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <input
                  type="text" required placeholder="e.g. Shivam Singh"
                  value={form.owner_name} onChange={set('owner_name')}
                  style={inputStyle} onFocus={onFocus} onBlur={onBlur}
                />
              </div>

              {/* Email + Phone — two columns */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>
                    Email <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <input
                    type="email" required placeholder="you@firm.com"
                    value={form.email} onChange={set('email')}
                    style={inputStyle} onFocus={onFocus} onBlur={onBlur}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>
                    Mobile <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <input
                    type="tel" required placeholder="9876543210"
                    value={form.phone} onChange={set('phone')}
                    style={inputStyle} onFocus={onFocus} onBlur={onBlur}
                  />
                </div>
              </div>

              {/* Password */}
              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>
                  Password <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <div style={{ position: 'relative' }}>
                  <input
                    type={showPassword ? 'text' : 'password'} required
                    placeholder="Min. 8 characters"
                    value={form.password} onChange={set('password')}
                    style={{ ...inputStyle, paddingRight: 42 }}
                    onFocus={onFocus} onBlur={onBlur}
                  />
                  <button type="button" onClick={() => setShowPassword(!showPassword)}
                    style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', display: 'flex', alignItems: 'center', padding: 0 }}>
                    {showPassword
                      ? <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" /></svg>
                      : <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>}
                  </button>
                </div>
              </div>

              {/* Confirm Password */}
              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>
                  Confirm Password <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <div style={{ position: 'relative' }}>
                  <input
                    type={showConfirm ? 'text' : 'password'} required
                    placeholder="Re-enter password"
                    value={form.confirm_password} onChange={set('confirm_password')}
                    style={{ ...inputStyle, paddingRight: 42 }}
                    onFocus={onFocus} onBlur={onBlur}
                  />
                  <button type="button" onClick={() => setShowConfirm(!showConfirm)}
                    style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', display: 'flex', alignItems: 'center', padding: 0 }}>
                    {showConfirm
                      ? <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" /></svg>
                      : <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>}
                  </button>
                </div>
              </div>

              {/* Error */}
              {error && (
                <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#dc2626' }}>
                  {error}
                </div>
              )}

              {/* Success */}
              {success && (
                <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#16a34a', fontWeight: 500 }}>
                  ✓ {success}
                </div>
              )}

              {/* Submit — exact same style as Login continue button */}
              <button
                type="submit" disabled={loading}
                style={{
                  width: '100%', padding: '13px 0', borderRadius: 8, border: 'none',
                  fontWeight: 600, color: '#fff', fontSize: 14,
                  cursor: loading ? 'not-allowed' : 'pointer',
                  background: loading ? '#93c5fd' : 'linear-gradient(135deg, #0f1f45, #1a3a6b)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                  boxShadow: loading ? 'none' : '0 4px 14px rgba(15,31,69,0.3)',
                  transition: 'opacity 0.2s', marginTop: 4,
                }}>
                {loading ? 'Creating your workspace…' : 'Start Free Trial'}
                {!loading && (
                  <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                )}
              </button>

              {/* Terms note */}
              <p style={{ fontSize: 11, color: '#9ca3af', textAlign: 'center', lineHeight: 1.6 }}>
                By registering you agree to our{' '}
                <a href="#" style={{ color: '#2563eb', textDecoration: 'none' }}>Terms of Service</a>
                {' '}and{' '}
                <a href="#" style={{ color: '#2563eb', textDecoration: 'none' }}>Privacy Policy</a>.
              </p>
            </form>
            )}

            {/* Security note — identical to Login */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, marginTop: 20, color: '#9ca3af', fontSize: 11 }}>
              <svg width="12" height="12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
              Your data is secure with enterprise-grade encryption
            </div>
          </div>
        </div>
      </div>

      {/* ── Responsive CSS — exact same as Login ── */}
      <style>{`
        * { box-sizing: border-box; }
        .login-left-panel { width: 45%; display: flex !important; }
        .login-mobile-logo { display: none !important; }
        @media (max-width: 768px) {
          .login-left-panel { display: none !important; }
          .login-mobile-logo { display: block !important; }
        }
        @media (max-width: 768px) {
          input[type="email"], input[type="password"], input[type="text"], input[type="tel"] {
            font-size: 16px !important;
          }
        }
        @media (max-width: 400px) {
          .login-right-panel-inner { padding: 28px 20px !important; }
        }
      `}</style>
    </div>
  );
}

export default Register;